/**
 * Subtle, accessible "Traffic Light" indicator used across the Care News hub.
 *
 *   <TrafficLight level="green" />    // 🟢 Awareness
 *   <TrafficLight level="amber" />    // 🟡 Watch closely
 *   <TrafficLight level="red" />      // 🔴 High impact
 *
 * Styled as a calm pill with a colour dot so it integrates naturally into the
 * existing JCC card / header design rather than reading as breaking-news alarm.
 */
const LEVELS = {
  green: {
    label: "Awareness",
    pill: "bg-emerald-50 text-emerald-800 border-emerald-200",
    dot: "bg-emerald-500",
  },
  amber: {
    label: "Watch closely",
    pill: "bg-amber-50 text-amber-900 border-amber-200",
    dot: "bg-amber-500",
  },
  red: {
    label: "High impact",
    pill: "bg-red-50 text-red-800 border-red-200",
    dot: "bg-red-500",
  },
};

export default function TrafficLight({ level, className = "", showLabel = true, size = "sm" }) {
  const cfg = LEVELS[(level || "").toLowerCase()];
  if (!cfg) return null;
  const sizing = size === "md"
    ? "px-3 py-1.5 text-xs"
    : "px-2.5 py-1 text-[11px]";
  const dotSize = size === "md" ? "w-2.5 h-2.5" : "w-2 h-2";
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border font-medium tracking-wide ${cfg.pill} ${sizing} ${className}`}
      data-testid={`traffic-light-${level}`}
      aria-label={`Care News update level: ${cfg.label}`}
    >
      <span className={`rounded-full ${cfg.dot} ${dotSize}`} aria-hidden="true" />
      {showLabel ? <span>{cfg.label}</span> : null}
    </span>
  );
}
